import { useLoaderData, useParams } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { BoardSlips } from "./BoardSlips";
import { IBoardSlipsSummaryData } from "./BoardSlipsData";
import { BoardsTitle } from "./BoardSlipsModels";

export const UnionBoardSlipsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  return doFetch(`board-slips/union-board/${params.board}`, { signal: request.signal }, true, true);
}

export const TelephoneBoardSlipsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  return doFetch(`board-slips/telephone-board/${params.board}`, { signal: request.signal }, true, true);
}

export const BoardSlipsRoute = () => {
  const data = useLoaderData() as IBoardSlipsSummaryData;
  const { board } = useParams();
  return (
    <BoardSlips data={data} board={board as keyof typeof BoardsTitle} />
  )
}